import React from 'react'
import SuccessStoryIcon from 'assets/images/funds/successStory.svg'
export default function SuccessStory() {
    return (
        <>
            <div className=" flex justify-between items-center mx-2 rounded-xl bg-blue-2 py-3 px-2  ">
                <div>
                    <p className=" text-blue-3 font-extrabold">
                        داستان موفقیت صندوق ها
                    </p>
                    <p className=" text-sm text-blue-4 my-1">
                        مدیریت صندوق به سبک حرفه ای ها
                    </p>
                    <button className=" bg-white rounded-full text-sm items-center py-1 px-4 mt-2 ">
                        بزودی
                    </button>
                </div>
                <img
                    src={SuccessStoryIcon}
                    alt="success-story"
                    className=" w-20"
                />
            </div>
        </>
    )
}
